import React, { useContext, useEffect, useState } from "react";
import { Accordion, AccordionContext, Card, Col, Container, Row, useAccordionButton } from "react-bootstrap";
import ButtonComp from "../../../Components/ButtonComp";
import WitmatesServices from "../../../http/witmates.service";
import Loading from "../../../Components/Loading";
import JobApplyForm from "./JobApplyForm";
import useMediaQuery from "../../../hooks/useMediaQuery";
import Svg from "../../../assets/Svgs/Svg";
import Animation from "../../../animations/Animation";

const { _getJobsListApi } = new WitmatesServices();

function AccordionHeader({ eventKey, lgBreakpoint, job }) {
   const decoratedOnClick = useAccordionButton(eventKey, () => console.log(""));
   const { activeEventKey } = useContext(AccordionContext);
   const isCurrentEventKey = activeEventKey === eventKey;
   return (
      <Container fluid className="description-container" onClick={decoratedOnClick} style={{ background: isCurrentEventKey ? "white" : "#0e0e0e" }}>
         <Container className="accordion-header">
            <Card.Header style={{ background: isCurrentEventKey ? "white" : "#0e0e0e" }}>
               <Row className="align-items-center pb20 pt20">
                  <Col xs={7} sm={7} md={8} lg={8} xl={8} xxl={8}>
                     <div className={isCurrentEventKey ? "text-black" : "colorWhite"}>
                        <h3 className="font-30 font-sm-18 fBold">{job?.designation}</h3>
                        <div className="d-flex align-items-center">
                           <div className="font-18 font-sm-12">Exp : {job.experience}</div>
                           <div className="font-18 font-sm-12" style={{ paddingLeft: "33px" }}>
                              {Svg.location} Indore
                           </div>
                        </div>
                     </div>
                  </Col>
                  <Col xs={5} sm={5} md={4} lg={4} xl={4} xxl={4} className={`d-flex mobMt20 mobMb20 justify-content-end`}>
                     <div style={{ ...(!lgBreakpoint ? { zoom: "0.7" } : {}) }}>
                        <ButtonComp title="APPLY NOW" isDefaultWhite={!isCurrentEventKey} />
                     </div>
                  </Col>
               </Row>
            </Card.Header>
         </Container>
      </Container>
   );
}

const CareersList = () => {
   const [loading, setLoading] = useState(true);
   const [jobList, setJobList] = useState([]);
   const lgBreakpoint = useMediaQuery("(min-width: 991px)");
   useEffect(() => {
      _getJobsListApi((loading, data, error) => {
         setLoading(loading);
         if (data) setJobList(data.data?.data?.jobs);
         if (error) setJobList([]);
      });
      return () => {};
   }, []);

   return (
      <>
         <section className="pt100 pb100 mobPt50 mobMb50 industryList careers bgBlack" id="apply-now">
            <Container className="mb-5 pb-3">
               <Row>
                  <Col className="text-center">
                     <Animation fade bottom>
                        <h2 className="fBold tabHeadingFontSize mobSubTitle colorWhite mt20">
                           Join Our <span className="colorOrange fBold">Team!</span>
                        </h2>
                        <p className="colorWhite fs18">
                           We Are Proud To Offer Competitive Benefits That Enable Healthy And <br /> Fulfilling Careers At Witmates.
                        </p>
                     </Animation>
                  </Col>
               </Row>
            </Container>
            <Loading loading={loading} size="5px" color="white" height="50vh" background="#0E0E0E">
               {jobList.length ? (
                  <Accordion defaultActiveKey="0">
                     {jobList.map((job, idx) => (
                        <Animation fade bottom>
                           <Card key={job.id} className="accordion-item">
                              <AccordionHeader eventKey={idx} job={job} lgBreakpoint={lgBreakpoint} />
                              <Container>
                                 <Accordion.Collapse eventKey={idx}>
                                    <Card.Body>
                                       <JobApplyForm JobData={job} actionCb={() => {}} />
                                    </Card.Body>
                                 </Accordion.Collapse>
                              </Container>
                           </Card>
                        </Animation>
                     ))}
                  </Accordion>
               ) : (
                  <div className="fBold mobSubTitle text-center py-5">
                     <h3 className="fBold tabHeadingFontSize mobSubTitle colorWhite mt20">No Job data</h3>
                  </div>
               )}
            </Loading>
         </section>
         {/* <section>
            <Container>
               <Row className="pt80 pb80">
                  <BottomBanner
                     height="446px"
                     extra={
                        <GAlign align="center">
                           <div className="mt25 ml0">
                              <ButtonComp title="Send message" isDefaultWhite />
                           </div>
                        </GAlign>
                     }
                     title="Let's Find a Solution That is Tailor-made for You! & Grow your Business"
                     description="We'r ready to help you. Our expert is here, just send a message."
                     image={Img.industrysolution}
                  />
               </Row>
            </Container>
         </section> */}
      </>
   );
};

export default CareersList;
